export const WRITING_ASSISTSANT_SEO_TITLE =
  'Free Writing Assistant (no sign-up required) | EasyBib.com'
export const WRITING_ASSISTSANT_SEO_DESCRIPTION =
  'Get free grammar suggestions, plus tools to shorten, expand, or paraphrase.'
